import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Action } from 'src/app/core/models/action.model';
import { GuideService } from 'src/app/modules/client/pages/guide/services/guide.service';
import { buildPrereqTooltip } from 'src/app/core/utils/prereq-tooltip.util';

@Component({
  selector: 'app-oa-questionnaire',
  templateUrl: './oa-questionnaire.component.html',
  styleUrls: ['./oa-questionnaire.component.scss', '../oa-styles.scss'],
})
export class OaQuestionnaireComponent implements OnInit {
  @Input() action!: Action;
  @Output() changed = new EventEmitter<boolean>();

  constructor(
    private guideService: GuideService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    console.log('[OA QUESTIONNAIRE] ngOnInit', this.action);
    // console.log('[OA QUESTIONNAIRE] prstatus:', this.action.prstatus);
    // console.log('[OA QUESTIONNAIRE] ac_status:', this.action.ac_status);
    // console.log('[OA QUESTIONNAIRE] checkDependsOn():', this.checkDependsOn());
  }

  checkDependsOn() {
    const isBlocked = !(
      (this.action.prstatus as any) === 'DONE' ||
      (this.action.prstatus as any) === null
    );
    // console.log('[OA QUESTIONNAIRE] checkDependsOn - prstatus:', this.action.prstatus, 'isBlocked:', isBlocked);
    return isBlocked;
  }

  /** CPK-4864: tooltip de bloqueio com o nome das actions pré-requisito pendentes. */
  get blockedTooltip(): string {
    return buildPrereqTooltip(this.action.blocking_prereq_names, this.translate);
  }

  /**
   * ✅ CPK-3911 (paridade com oa-kyc/oa-signature): se o claim desta action
   * ainda exige o guide, redireciona para lá em vez de abrir o questionário
   * diretamente a partir do card fora do guide.
   */
  async openQuestionnaire(): Promise<void> {
    if (this.checkDependsOn() || this.action.ac_status === 'SUBMITTED') {
      return;
    }

    if (this.action.claim_id) {
      const requiresGuide = await this.guideService.claimRequiresGuide(
        this.action.claim_id
      );

      if (requiresGuide) {
        console.log('[OA] [QUESTIONNAIRE] Claim still requires guide, redirecting', {
          claimId: this.action.claim_id,
        });
        this.router.navigateByUrl(`client/claim/${this.action.claim_id}/guide`);
        return;
      }
    }

    this.router.navigate([
      '/client/claim',
      this.action.claim_id,
      'q',
      this.action.questionnaire_id,
    ]);
  }
}
